import { RenditionType } from 'const';
import { ImageInternalInfo } from 'models';
import { ImageCacheData, ImageCacheDataMap } from './models';

export class ImageCache {
  private static instance: ImageCache;

  private readonly data: ImageCacheDataMap;

  constructor() {
    this.data = {} as ImageCacheDataMap;
  }

  public static getInstance(): ImageCache {
    if (!ImageCache.instance) {
      ImageCache.instance = new ImageCache();
    }

    return ImageCache.instance;
  }

  private getDataKey(type: RenditionType, checksum: string): string {
    return `${type}#${checksum}`;
  }

  public getItem(type: RenditionType, checksum: string): ImageInternalInfo | string[] {
    const key = this.getDataKey(type, checksum);

    return this.data[key];
  }

  public setItem(type: RenditionType, checksum: string, cacheData: ImageCacheData): void {
    const key = this.getDataKey(type, checksum);

    this.data[key] = cacheData;
  }
}
